module.exports = __webpack_public_path__ + "img/Boton_Enviar.603faf2a.png";